<template>
  <div>
    <div>
      <h4 class="text-green text-center">保障摘要</h4>
      <section class="row">
        <table class="table datatable">
          <thead>
            <tr>
              <th width="100" class="text-center">保障項目</th>
              <th width="30" class="text-center">承保對象</th>
              <th width="30" class="text-center">年期</th>
              <th width="150" class="text-center">公式內容</th>
              <th width="120" class="text-center" v-if="showGuidAndNo">GUID</th>
              <th width="30" class="text-center" v-if="showGuidAndNo">順序</th>
            </tr>
          </thead>
          <tbody v-if="formularData.length">
            <tr v-for="(data, i) in formularData" :key="`tradition-data-${i}`">
              <td>{{ data.item }}</td>
              <td>{{ data.target }}</td>
              <td>{{ data.year }}</td>
              <td style="white-space: pre-line">{{ data.content }}</td>
              <td v-if="showGuidAndNo">{{ data.guid }}</td>
              <td v-if="showGuidAndNo">{{ data.no }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="6">
                <h4 class="mb-3">查無保障公式摘要資訊</h4>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCoverageSummary } from "@/service";
export default {
  name: "CoverageFormulaSummary",
  mixins: [],
  data() {
    return {
      formularData: [],
      productData: JSON.parse(localStorage.productData),
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    showGuidAndNo() {
      return true
      //原邏輯，商品種類為傳統型(取大)時不顯示GUID與順序
      // return this.productData.productType != 4; 
    }
  },
  created() {
    this.queryFormularData();
  },
  methods: {
    queryFormularData() {
      const req = {
        productId: this.productData.productId,
        productType: this.productData.productType,
        schemeData: this.productData.schemeData,
      };
      getCoverageSummary(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formularData = result.data;
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}

.ml-40 {
  margin-left: 40px;
}
</style>
